import { render, staticRenderFns } from "./SingleClientAppOrder.vue?vue&type=template&id=ebb8144e&"
import script from "./SingleClientAppOrder.vue?vue&type=script&lang=js&"
export * from "./SingleClientAppOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports